class DagiProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.list = this.track?.querySelector('.dagi-product-rec__list');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');

    if (!this.track || !this.list) return;

    this.prev?.addEventListener('click', () => this.scrollBy(-1));
    this.next?.addEventListener('click', () => this.scrollBy(1));
  }

  scrollBy(direction) {
    const item = this.list.querySelector('.dagi-product-rec__item');
    if (!item) return;

    const gap = parseFloat(getComputedStyle(this.list).gap) || 16;
    const amount = (item.offsetWidth + gap) * direction;
    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }
}

if (!customElements.get('dagi-product-carousel')) {
  customElements.define('dagi-product-carousel', DagiProductCarousel);
}
